import { useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import { IUnlistedStatsResponse } from "../models/Part";


export default function useListingStats() {
  const { get, post, put, patch, del } = useApiHelper();
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60 * 10; //10 minutes

  const unlistedStats = useQuery({
    queryKey: ["listingStats", "unlisted"],
    queryFn: () => get<DefaultResponseWithData<IUnlistedStatsResponse>>("/part/stats/unlisted"),
    staleTime,
  });


  return {
    unlistedStats
  }
}